import { ListChecks } from "lucide-react";
import posthog from "posthog-js";
import { OnboardingProgress } from "../hooks/useOnboardingProgress";

interface MobileSetupBadgeProps {
  progress: OnboardingProgress;
  onTap: () => void;
}

export function MobileSetupBadge({ progress, onTap }: MobileSetupBadgeProps) {
  if (progress.loading || progress.allDone || progress.dismissed) return null;

  const remaining = 4 - progress.doneCount;
  const label = `Setup — ${remaining} ${remaining === 1 ? "item" : "items"} remaining`;

  const handleTap = () => {
    posthog.capture("mobile_setup_badge_tapped", { incomplete_count: remaining });
    onTap();
  };

  return (
    <button
      type="button"
      onClick={handleTap}
      aria-label={label}
      className="relative inline-flex items-center justify-center h-8 w-8 rounded-md hover:bg-gray-100 transition-colors"
    >
      <ListChecks className="h-4 w-4 text-gray-600" aria-hidden="true" />
      <span
        aria-hidden="true"
        className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-[#FF5C35] text-[10px] font-semibold text-white tabular-nums leading-none"
      >
        {remaining}
      </span>
    </button>
  );
}
